import Button from "features/media/components/atoms/Button";
import { TopicElement } from "shared/types";

interface Props {
  data: TopicElement;
}

export default function LinkButton({ data }: Props) {
  const onClick = () => {
    window.open(data.siteUrl, "_blank", "noreferrer");
  };

  return <Button onClick={onClick}>{data.title}</Button>;
}
